module.exports = __webpack_public_path__ + "static/blog12-6aae18bdee603ee9ad4fc8a3b9d4ca33.png";